import { placeholders } from 'components/Phone/placeholders';
import { cdnURL } from 'utils/helpers';

import { WizardState } from '../wizardModel';
import { CampaignFormValues } from '../wizardSubmission';
import { AdapterContext, baseValues, durationValues, limitValue, toOutcome } from './common';
import { toCampaignRule, toSavedRule } from './ruleAdapter';

/**
 * The quest landing copy the module requires and the wizard never asks: the headline is the
 * campaign name (as the module seeds it), the rest a placeholder to edit in the module.
 */
export const QUEST_LANDING_PLACEHOLDER = 'Complete every task to earn your reward.';

// The module's own seed for a new task (`QuestTasks` handleAddTask).
const taskImage = () => ({
  type: 'image',
  value: { filename: 'task_icon.png', image_url: cdnURL('task_icon.png') }
});

export const questValues = (state: WizardState, context: AdapterContext): CampaignFormValues => {
  const { limits } = state;
  const name = state.name.trim();
  return {
    ...baseValues(state, 'quest', context, true),
    quest_tasks: state.triggers.map((trigger, index) => {
      const rule = toSavedRule(toCampaignRule(trigger, 'quest', context.t));
      return {
        title: rule.name,
        ordering: index + 1,
        display_properties: { image: taskImage() },
        rule
      };
    }),
    outcomes: state.prizes.map(toOutcome),
    campaign_lifetime_max_available: limitValue(limits.totalOn, limits.total),
    account_lifetime_max_available: limitValue(limits.perUserOn, limits.perUser),
    ...durationValues(limits),
    display_properties: { ...placeholders.quest.static },
    display_properties_en: {
      header: { value: { title: name, description: QUEST_LANDING_PLACEHOLDER } },
      body: QUEST_LANDING_PLACEHOLDER
    }
  };
};
